var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loaderSend"},[_c('b-icon',{attrs:{"icon":"envelope-fill","animation":"cylon","font-scale":"4"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }